import React, { useEffect, useRef, useState } from "react";
import { loadVouched, unloadVouched } from "./vouched-script";
import { withRouter } from "react-router-dom";
import "./idVerification.css";
import IdVerificaitonService from "./IdVerificationService.jsx";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import FormControl from "react-bootstrap/FormControl";
import Result from "../../../components/result/Result.jsx";
import { Spinner } from "react-bootstrap";
import { utils } from "../../../utils/Utils.jsx";
import ErrorMessageComponent from "../../../components/errorMessageComponent/ErrorMessageComponent.jsx";

function IdVerificaiton(props) {
  const [state, setState] = useState({
    isMobileWidth: false,
    fullName: "",
    fullLastName: "",
    invalidFullname: false,
    invalidLastname: false,
    resultSuccess: null,
    resultType: "",
    errorMessageType: "",
    finishedLoading: false,
    publicKey: "",
    goBackURL: null,
    stage: 1,
    kycPolling: false,
    lastJobId: null,
  });

  const vouchedRef = useRef(null);
  const serviceRef = useRef(new IdVerificaitonService());
  const pollRef = useRef(null);

  const setPartialState = (values) => {
    setState((prevState) => ({
      ...prevState,
      ...values,
    }));
  };

  const moveToResult = (value, type) => {
    setPartialState({
      stage: 3,
      resultSuccess: value,
      resultType: type,
    });
  };

  const setMessages = (type) => {
    setPartialState({
      errorMessageType: type,
    });
  };

  const startKycPolling = (jobId) => {
    if (pollRef.current) clearInterval(pollRef.current);

    setPartialState({ kycPolling: true });

    pollRef.current = setInterval(() => {
      serviceRef.current.pollKycStatus(
        props.token,
        props.config?.email,
        (status) => {
          if (status.kycCompleted === true || status.kycStatus === "COMPLETED") {
            clearInterval(pollRef.current);
            pollRef.current = null;
            setPartialState({ kycPolling: false });
            if (props.getClientConfig) props.getClientConfig();
            moveToResult(true, "general");
          } else if (status.kycStatus === "REJECTED") {
            clearInterval(pollRef.current);
            pollRef.current = null;
            setPartialState({ kycPolling: false, lastJobId: jobId });
            moveToResult(false, "general");
          }
        },
      );
    }, 10000);
  };

  const startVerification = () => {
    setPartialState({
      errorMessageType: "",
    });

    if (state.fullName != "" && state.fullLastName != "") {
      loadVouched(
        {
          publicKey: props.publicKey || state.publicKey,
          firstName: state.fullName,
          lastName: state.fullLastName,
          email: props.config?.email,
          callbackURL: props.callbackURL,
          reverificationJobId: state.lastJobId,
          onInit: ({ token, job }) => {
            console.log("Initialized", job);
            setPartialState({ finishedLoading: true });
          },
          onDone: (job) => {
            console.log("Vouched job done", job);
            if (props.onVouchedDone) {
              props.onVouchedDone(job);
            }
            // Notify backend of job submission (legacy, still useful as backup)
            serviceRef.current.vouchedJobSubmitted(
              props.token,
              job.id,
              () => {}, // Don't navigate on submit — let polling handle it
              () => {},
            );
            // Start polling for webhook-driven KYC result
            startKycPolling(job.id);
          },
        },
        vouchedRef,
      );
      setPartialState({ stage: state.stage + 1 });
    } else {
      setPartialState({
        invalidFullname: state.fullName == "",
        invalidLastname: state.fullLastName == "",
      });
      setMessages("one-or-more-required-fields-are-missing");
    }
  };

  const getResultMessage = () => {
    if (state.resultType == "general") {
      if (state.resultSuccess) {
        return props.localizedText[
          "your-identification-has-been-successfully-verified"
        ];
      }

      return props.localizedText[
        "unfortunately-we-have-encountered-a-problem-while-trying-to-verify-your-identity"
      ];
    }

    if (state.resultType == "already-verified") {
      if (state.resultSuccess) {
        return "";
      }

      return props.localizedText[
        "looks-like-your-identity-has-already-been-verified"
      ];
    }

    return "";
  };

  useEffect(() => {
    serviceRef.current.getClientConfig(props.token, setPartialState);

    if (props.location?.megastate?.fromSettings) {
      setPartialState({
        goBackURL: "/dashboard/settings",
      });
    } else {
      setPartialState({
        goBackURL: "/dashboard/",
      });
    }

    const resizeHandler = () => {
      utils.checkWindowWidth(
        setPartialState,
        props.changeGoBackNavBar,
        true,
        "/dashboard",
      );
    };

    resizeHandler();
    window.addEventListener("resize", resizeHandler);

    return () => {
      window.removeEventListener("resize", resizeHandler);
      unloadVouched(vouchedRef);
      if (pollRef.current) clearInterval(pollRef.current);
    };
  }, []);

  const renderStage1 = () => (
    <>
      <div class="page-subtitle">
        {
          props.localizedText[
            "to-setupt-your-account-for-trading-we-need-to-verify-your-identity"
          ]
        }
      </div>
      <div class="content-container-no-hover fade-in-up">
        <div class="div-parent-flex-column">
          <Form.Group className="mb-3">
            <Form.Label className="input-label-outside-div">
              {props.localizedText["full-name"]}
            </Form.Label>
            <FormControl
              type="text"
              name="fullName"
              value={state.fullName}
              onChange={(e) => utils.handleChange(e, setPartialState)}
              isInvalid={state.invalidFullname}
              className="input-field"
              placeholder={props.localizedText["enter-first-name-as-on-id"]}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="input-label-outside-div">
              {props.localizedText["full-last-name"]}
            </Form.Label>
            <FormControl
              name="fullLastName"
              value={state.fullLastName}
              onChange={(e) => utils.handleChange(e, setPartialState)}
              isInvalid={state.invalidLastname}
              className="input-field"
              placeholder={props.localizedText["enter-last-name-as-on-id"]}
            />
          </Form.Group>
          <ErrorMessageComponent
            errorMessage={props.localizedText[state.errorMessageType]}
          ></ErrorMessageComponent>
          <div class="buttons-div">
            <Button
              className="primary-button outside-primary-button"
              onClick={startVerification}
            >
              {props.localizedText["continue"]}
            </Button>

            <Button
              className="secondary-button outside-secondary-button"
              onClick={utils.goToURL.bind(this, props, state.goBackURL)}
            >
              {props.localizedText["cancel"]}
            </Button>
          </div>
        </div>
      </div>
    </>
  );

  const renderStage2 = () => (
    <div
      style={{
        height: "100%",
        width: "100%",
      }}
    >
      {state.kycPolling ? (
        <div
          className="content-container-no-hover fade-in-up"
          style={{
            textAlign: "center",
            padding: "3rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <Spinner size="m" />
          <p>
            {props.localizedText["verifying-your-identity"] ||
              "Verifying your identity. This may take a few moments..."}
          </p>
        </div>
      ) : (
        <div
          id="vouched-element"
          style={{
            height: "100%",
          }}
        ></div>
      )}
    </div>
  );

  return (
    <React.Fragment>
      <div class="id-verification-container page-container">
        <div class="middle-container container-padding">
          {state.stage != 3 ? (
            <div className="form-container">
              <div class="main-title">
                {props.localizedText["id-verification"]}
              </div>
              {state.stage === 1 ? renderStage1() : null}
              {state.stage === 2 ? renderStage2() : null}
              {state.stage === 2 && !state.finishedLoading ? (
                <div class="loading-vouched">
                  <Spinner className="loader"></Spinner>
                </div>
              ) : null}
            </div>
          ) : (
            <Result
              success={state.resultSuccess}
              secondButton={false}
              title={
                props.localizedText[utils.getResultTitle(state.resultSuccess)]
              }
              message={getResultMessage()}
              primaryButtonText={props.localizedText["continue"]}
              primaryButtonFunction={utils.goToURL.bind(
                this,
                props,
                state.goBackURL,
              )}
            ></Result>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default withRouter(IdVerificaiton);
